// extracted by mini-css-extract-plugin
export default {"container":"account-allowances_container__gLP9f","code":"account-allowances_code__+EwbH"};